/**
* 视图配置模板
* Author: dong xing
* Date: 2019/11/13
* Time: 1:44 下午
* Email: dong.xing@outlook.com
*/
<template>
  <div class="comment-template">
    <div class="comment-template__header">
      <p class="comment-template__name">画板</p>
    </div>
    <div class="view-config">

      <a-collapse :activeKey="activeKey" :bordered="false">

        <!-- S 尺寸 -->
        <a-collapse-panel header="尺寸" key="1">

          <div class="comment-template__item">
            <p class="comment-template__leading">宽:</p>
            <div class="comment-template__inner">
              <a-input
                type="number"
                v-model.number="config.commonConfig.width"
                @change="change" />
            </div>
          </div>
          <!-- / 宽 -->

          <div class="comment-template__item">
            <p class="comment-template__leading">高:</p>
            <div class="comment-template__inner">
              <a-input
                type="number"
                v-model.number="config.commonConfig.height"
                @change="change" />
            </div>
          </div>
          <!-- / 高 -->

        </a-collapse-panel>
        <!-- E 尺寸 -->

        <!-- E 背景 -->
        <a-collapse-panel header="背景" key="2" class="visible-collapse-panel">

          <div class="comment-template__item">
            <p class="comment-template__leading">模式:</p>
            <div class="comment-template__inner comment-template__end">
              <a-radio-group
                buttonStyle="solid"
                v-model="config.proprietaryConfig.mode"
                @change="modeChange">
                <a-radio-button value="single">单一</a-radio-button>
                <a-radio-button value="linear">渐变</a-radio-button>
                <a-radio-button value="image">图片</a-radio-button>
              </a-radio-group>
            </div>
          </div>
          <!-- / 模式 -->

          <div class="comment-template__item" v-if="config.proprietaryConfig.mode === 'single'">
            <div class="comment-template__inner">
              <ColorPicker
                v-model="config.proprietaryConfig.backgroundColor"
                @change="singleColorChange" />
            </div>
          </div>
          <!-- / 单一颜色 -->

          <div class="comment-template__item" v-if="config.proprietaryConfig.mode === 'linear'">
            <div class="comment-template__inner">
              <LinearColorPicker
                show-angle
                v-model="config.proprietaryConfig.backgroundColor"
                @change="linearColorChange" />
            </div>
          </div>
          <!-- / 渐变颜色 -->

          <div v-if="config.proprietaryConfig.mode === 'image'">
            <div class="comment-template__item">
              <p class="comment-template__leading">图片:</p>
              <div class="comment-template__inner">
                <a-input
                  type="text"
                  v-model.trim="config.proprietaryConfig.backgroundImage"
                  @change="change" />
              </div>
            </div>
            <!-- / 图片 -->

            <div class="comment-template__item">
              <p class="comment-template__leading">重复:</p>
              <div class="comment-template__inner">
                <a-select
                  v-model="config.proprietaryConfig.backgroundRepeat"
                  @change="change">
                  <a-select-option value="no-repeat">不重复</a-select-option>
                  <a-select-option value="repeat">重复</a-select-option>
                  <a-select-option value="repeat-x">水平重复</a-select-option>
                  <a-select-option value="repeat-y">垂直重复</a-select-option>
                </a-select>
              </div>
            </div>
            <!-- / 尺寸 -->

            <div class="comment-template__item">
              <p class="comment-template__leading">尺寸:</p>
              <div class="comment-template__inner">
                <a-select
                  v-model="config.proprietaryConfig.backgroundSize"
                  @change="change">
                  <a-select-option value="">默认大小</a-select-option>
                  <a-select-option value="contain">伸展扩展以适配屏幕</a-select-option>
                  <a-select-option value="cover">等比扩展以适配屏幕</a-select-option>
                </a-select>
              </div>
            </div>
            <!-- / 尺寸 -->

          </div>

        </a-collapse-panel>
        <!-- E 背景 -->

        <!-- S 显示 -->
        <a-collapse-panel header="显示" key="3">

          <div class="comment-template__item">
            <p class="comment-template__leading">缩放模式:</p>
            <div class="comment-template__inner">
              <a-select
                v-model="config.proprietaryConfig.scaleMode"
                @change="change">
                <a-select-option value="auto">自适应</a-select-option>
                <a-select-option value="primary">原始尺寸</a-select-option>
                <a-select-option value="fullscreen">全屏显示</a-select-option>
                <a-select-option value="fullWidth">等比宽度铺满</a-select-option>
                <a-select-option value="fullHeight">等比高度铺满</a-select-option>
              </a-select>
            </div>
          </div>
          <!-- / 缩放模式 -->

        </a-collapse-panel>
        <!-- E 显示 -->

        <!-- S 屏幕截图 -->
        <a-collapse-panel header="封面" key="4">

          <div class="view-config__screen">
            <div class="view-config__screenshot">
              <img :src="config.proprietaryConfig.cover" alt="" v-if="config.proprietaryConfig.cover" />
              <p v-else>视图封面</p>
            </div>
          </div>

          <div class="comment-template__item">
            <p class="comment-template__leading">封面:</p>
            <div class="comment-template__inner">
              <a-textarea
                ref="screenshot"
                type="text"
                v-model.trim="config.proprietaryConfig.cover"
                @change="change" />
            </div>
          </div>
          <!-- / 封面 -->

        </a-collapse-panel>
        <!-- E 屏幕截图 -->

        <!-- S 网格 -->
        <a-collapse-panel header="网格" key="5">

          <div class="comment-template__item">
            <p class="comment-template__leading">网格:</p>
            <div class="comment-template__inner comment-template__end">
              <a-switch size="small" checked-children="开" un-checked-children="关" v-model="isGrid" @change="handleSwitch" />
            </div>
          </div>
          <!-- / 宽 -->

          <div class="comment-template__item">
            <p class="comment-template__leading">尺寸:</p>
            <div class="comment-template__inner">
              <a-slider
                :min="0"
                :max="100"
                :step="2"
                v-model.number="gridSize"
                @change="handleChangeGridSize"
              />
            </div>
          </div>
          <!-- / 高 -->

        </a-collapse-panel>
        <!-- E 网格 -->

      </a-collapse>

    </div>
  </div>
</template>

<script>
import '@/assets/less/template.less'
import _ from 'lodash'
import { fromEvent } from 'rxjs'
import { takeWhile, map, filter, switchMap } from 'rxjs/operators'
import { mapState, mapMutations } from 'vuex'
import { ScreenMutations } from '@/store/modules/screen'
import ColorPicker from '@/components/ColorPicker'
import LinearColorPicker from '@/components/LinearColorPicker'
import ViewService from './index'

export default {
  name: 'ViewConfig',
  components: {
    ColorPicker,
    LinearColorPicker
  },
  data: () => ({
    isSubscribed: true,
    singleColor: 'rgba(255, 255, 255, 1)',
    linearColor: {
      start: 'rgba(255, 255, 255, 1)',
      end: 'rgba(0, 0, 0, 1)',
      angle: 180
    },
    activeKey: [1, 2, 3, 4, 5],
    viewService: new ViewService(),
    isGrid: false,
    gridSize: 20
  }),
  mounted () {
    // Todo 之后连接数据库后，做成上传，暂时将以本地 base64 图片储存，图片质量太大但是会有很大的性能问题
    // 监听粘贴时间，将粘贴板中的图片转成 base64
    fromEvent(this.$refs.screenshot.$el, 'paste')
      .pipe(
        takeWhile(() => this.isSubscribed),
        map(event => event.clipboardData && event.clipboardData.items),
        filter(items => items.length > 0 && items[0].type.indexOf('image') !== -1),
        switchMap(item => {
          const reader = new FileReader()
          reader.readAsDataURL(item[0].getAsFile())
          return fromEvent(reader, 'load')
        })
      )
      .subscribe(({ currentTarget }) => {
        this.config.proprietaryConfig.cover = currentTarget.result || ''
        this.change()
      })
  },
  computed: {
    ...mapState('screen', ['view', 'scale']),
    config () {
      return _.cloneDeep(this.view.config)
    }
  },
  methods: {
    ...mapMutations('screen', {
      setView: ScreenMutations.SET_VIEW,
      updateState: ScreenMutations.UPDATE_STATE
    }),
    /**
     * 单一颜色更改
     */
    singleColorChange () {
      this.singleColor = this.config.proprietaryConfig.backgroundColor
      this.change()
    },
    /**
     * 渐变颜色更改
     */
    linearColorChange () {
      this.linearColor = this.config.proprietaryConfig.backgroundColor
      this.change()
    },
    /**
     * 模式更改
     */
    modeChange () {
      if (this.config.proprietaryConfig.mode !== 'image') {
        const backgroundColor = this.config.proprietaryConfig.mode === 'single'
          ? this.singleColor
          : this.linearColor
        Object.assign(this.config.proprietaryConfig, { backgroundColor })
      }
      this.change()
    },
    /**
     * 开启网格
     */
    handleSwitch () {
      this.updateState({ isGrid: this.isGrid })
    },
    /**
     * 修改网格尺寸
     */
    handleChangeGridSize () {
      document.documentElement.style.setProperty('--grid-size', `${this.gridSize}px`)
      this.updateState({ gridSize: this.gridSize })
    },
    change () {
      this.setView({
        view: Object.assign(this.view, { config: this.config })
      })
      this.viewService.next('adjust')
    }
  },
  destroyed () {
    this.isSubscribed = false
  }
}
</script>

<style scoped lang="less">
.view-config {
  height: 100%;
  width: 100%;
  overflow: auto;
  padding-top: 16px;

  &__content {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-evenly;
    align-items: center;

    .ant-input-group-wrapper {
      margin: 0 12px;
    }
  }

  &__screen {
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: center;

    & button {
      width: 100%;
    }
  }

  &__screenshot {
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 140px;
    margin: 0 12px 12px;
    background: #e4e4e4;
    padding: 6px;
    border-radius: 4px;

    img {
      max-width: 100%;
      max-height: 100%;
    }

    p {
      color: #1890ff;
      margin: 0;
    }
  }
}
</style>
